import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  AccordionDetails,
  Button,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  Link,
  MenuItem,
  Radio,
  RadioGroup,
  Stack,
  Tooltip
} from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useTab } from 'src/components/hooks/useTab';
import { useUser } from 'src/components/hooks/useUser';
import { sendRequest } from 'src/hooks/useFetch';
import { useGetCodeListDataQuery } from 'src/services/codeList';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
// import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { clearMessage, setMessage } from 'src/store/Message';
import { setPath } from 'src/store/Navigation';
import { ISIVChecklistSiteAdequacy } from 'src/types/SIVChecklist';
import { formatInput } from 'src/util/STR';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import {
  ISiteAdequacyMandatory,
  ISIVChecklistMandatory,
  ISIVChecklistModifiedKeys,
  ISIVChecklistModifiedKeysOfKeys,
  MandatoryData
} from './useSivChecklist';
import { setIsSaveButtonDisable } from 'src/store/sivCheckList';

const pointer = { cursor: 'pointer' };

export interface ISiteAdequacy {
  siteAdequacyData: ISIVChecklistSiteAdequacy;
  updateSiteAdequacyData: (data: ISIVChecklistSiteAdequacy) => void;
  getSivChecklistData: (key: ISIVChecklistModifiedKeysOfKeys, add: boolean) => void;
  saveDisable: boolean;
  setSaveDisable: (saveDisable: boolean) => void;
  isUpdate: boolean;
  isChange: boolean;
  setIsChange: (step: ISIVChecklistModifiedKeys, key: ISIVChecklistModifiedKeysOfKeys, val: boolean) => void;
  updateSIVChecklistMandatoryData: (key: keyof ISIVChecklistMandatory, value: MandatoryData) => void;
  mandatory: ISiteAdequacyMandatory;
  validatesiteAdequacy: any;
  checkedInStartDate: any;
  isPublished: boolean;
  SignatureBreaking: () => void;
}
const SiteAdequacy: React.FunctionComponent<ISiteAdequacy> = ({
  getSivChecklistData,
  saveDisable,
  setSaveDisable,
  siteAdequacyData,
  updateSiteAdequacyData,
  isUpdate,
  isChange,
  setIsChange,
  mandatory,
  updateSIVChecklistMandatoryData,
  validatesiteAdequacy,
  checkedInStartDate,
  isPublished,
  SignatureBreaking
}) => {
  const { checklistSiteAdequacy } = useFieldTranslation();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const { sivcDataUpdateSuccessMsg, sivcMendatoryInfoErrorMsg } = useFieldTranslation();
  const user = useUser();
  const { checkPermission } = usePermissionWrapper();
  const isDisable = checkPermission('update_siv_checklist');
  const { setTabVal, tabsData } = useTab();
  const selectedRowData: any = useAppSelector(state => state.sivCheckList.selectedRowData);
  const saveButtonDisable: any = useAppSelector(state => state.sivCheckList.disableSaveButtonProps);

  const updateSiteAdequancyData = async () => {
    const clonedObj: any = { ...siteAdequacyData };
    if (
      siteAdequacyData.siv_checklist_fics_list !== null &&
      siteAdequacyData.siv_checklist_fics_list == 'Y' &&
      siteAdequacyData.siv_checklist_study_supplies !== null
    ) {
      if (siteAdequacyData.siv_checklist_doa == '') {
        clonedObj.siv_checklist_doa = 'NA';
      }
      if (siteAdequacyData.siv_checklist_siv_training == '') {
        clonedObj.siv_checklist_siv_training = 'NA';
      }
      if (siteAdequacyData.siv_checklist_contact_list == '') {
        clonedObj.siv_checklist_contact_list = 'NA';
      }
    }
    const options = {
      site_id: selectedSite,
      study_id: studyId,
      data: {
        created_by: user.user,
        updated_by: user.user,
        monitoring_visit_id: selectedRowData.id,
        siv_checklist: { step_one: { site_adequancy: clonedObj } }
      },
      pathVariables: {
        country: selectedCountry,
        appName: process.env.REACT_APP_NAME
      }
    };
    try {
      if (isChange) {
        if (isUpdate) {
          if (
            (siteAdequacyData.siv_checklist_fics_list !== null &&
              siteAdequacyData.siv_checklist_fics_list == 'N' &&
              siteAdequacyData.siv_checklist_contact_list !== null &&
              siteAdequacyData.siv_checklist_doa !== null &&
              siteAdequacyData.siv_checklist_siv_training !== null &&
              siteAdequacyData.siv_checklist_contact_list !== '' &&
              siteAdequacyData.siv_checklist_doa !== '' &&
              siteAdequacyData.siv_checklist_siv_training !== '' &&
              siteAdequacyData.siv_checklist_contact_list !== 'NA' &&
              siteAdequacyData.siv_checklist_doa !== 'NA' &&
              siteAdequacyData.siv_checklist_siv_training !== 'NA' &&
              siteAdequacyData.siv_checklist_study_supplies !== null &&
              siteAdequacyData.siv_checklist_study_supplies !== '') ||
            (siteAdequacyData.siv_checklist_fics_list !== null &&
              siteAdequacyData.siv_checklist_fics_list == 'Y' &&
              siteAdequacyData.siv_checklist_study_supplies !== null &&
              siteAdequacyData.siv_checklist_study_supplies !== '')
          ) {
            try {
              await sendRequest('update_sivChecklist_data', options);
              if (isPublished) {
                SignatureBreaking();
              }
              getSivChecklistData('siteAdequacy', false);
              setConfirmExitValue(dispatch, false);
              setIsChange('Step1', 'siteAdequacy', false);
              dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
            } catch (error: any) {
              if (error && error?.response?.status === 403) {
                dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
              } else if (error && error.response?.status === 401) {
                dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
              } else {
                dispatchApp(setMessage({ msgDetails: 'Error while update data', severity: 'error' }));
              }
            }
          } else {
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
        if (!isUpdate) {
          if (
            (siteAdequacyData.siv_checklist_fics_list !== null &&
              siteAdequacyData.siv_checklist_fics_list == 'N' &&
              siteAdequacyData.siv_checklist_contact_list !== null &&
              siteAdequacyData.siv_checklist_doa !== null &&
              siteAdequacyData.siv_checklist_siv_training !== null &&
              siteAdequacyData.siv_checklist_contact_list !== '' &&
              siteAdequacyData.siv_checklist_doa !== '' &&
              siteAdequacyData.siv_checklist_siv_training !== '' &&
              siteAdequacyData.siv_checklist_contact_list !== 'NA' &&
              siteAdequacyData.siv_checklist_doa !== 'NA' &&
              siteAdequacyData.siv_checklist_siv_training !== 'NA' &&
              siteAdequacyData.siv_checklist_study_supplies !== null) ||
            (siteAdequacyData.siv_checklist_fics_list !== null &&
              siteAdequacyData.siv_checklist_fics_list == 'Y' &&
              siteAdequacyData.siv_checklist_study_supplies !== null)
          ) {
            await sendRequest('create_sivChecklist_data', options);
            getSivChecklistData('siteAdequacy', true);
            setConfirmExitValue(dispatch, false);
            setIsChange('Step1', 'siteAdequacy', false);
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
          } else {
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
      } else if (validatesiteAdequacy) {
        dispatchApp(setMessage({ msgDetails: 'No data modified', severity: 'info' }));
      } else {
        dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
      }
      dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, siteAdequacy: true }));
    } catch (e) {
      dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
    }
  };

  const { data } = useGetCodeListDataQuery('SIVEQPL');
  const [equipmentData, setequipmentData] = useState<any>([]);
  useEffect(() => {
    if (data) {
      setequipmentData(data.map((ele: any) => ele.code_list_value));
    }
  }, [data]);
  const handleAddEquipment = (event: SelectChangeEvent) => {
    if (siteAdequacyData.siv_checklist_equipment.indexOf(event.target.value) !== -1) {
      return;
    } else {
      if (event.target.value === '') {
        //setEquipmentList([]);
        updateSiteAdequacyData({ ...siteAdequacyData, siv_checklist_equipment: [] });
        //setIsChange(true);
      } else {
        //setEquipmentList([...siteAdequacyData.siv_checklist_equipment, event.target.value]);
        updateSiteAdequacyData({
          ...siteAdequacyData,
          siv_checklist_equipment: [...siteAdequacyData.siv_checklist_equipment, event.target.value]
        });
        //setIsChange(true);
      }
    }
  };

  const handleSiteAdequancyData = (e: any) => {
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    const value = formattedVal;
    dispatchApp(clearMessage());
    if (e.target.type === 'radio' && value === 'Y') {
      updateSiteAdequacyData({ ...siteAdequacyData, [e.target.name]: value, [`${e.target.name}_comm`]: '' });
      //setValidate({ ...validate, [e.target.name]: false });
      updateSIVChecklistMandatoryData('siteAdequacy', { ...mandatory, [e.target.name]: false });
    } else {
      updateSiteAdequacyData({ ...siteAdequacyData, [e.target.name]: value });
    }

    const validateKey = `${e.target.name.replace('_comm', '')}`;
    if (e.target.name?.indexOf('_comm') !== -1) {
      if (!(value && value !== null && value !== '')) {
        updateSIVChecklistMandatoryData('siteAdequacy', { ...mandatory, [validateKey]: true });
      } else {
        updateSIVChecklistMandatoryData('siteAdequacy', { ...mandatory, [validateKey]: false });
      }
    }
    dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, siteAdequacy: false }));
    setConfirmExitValue(dispatch, true);
  };

  const handleDelete = (value: string) => {
    const equipments = [...siteAdequacyData.siv_checklist_equipment];
    const newEquipments = equipments.filter((item: string) => item !== value);
    //setEquipmentList(newEquipments);
    updateSiteAdequacyData({
      ...siteAdequacyData,
      siv_checklist_equipment: newEquipments
    });
    //console.info('You clicked the delete icon.');
  };

  // *Start* - PICTMS-2807 - Navigation to respective pages
  const navigateToTab = (path: string, tabTitle: string) => {
    dispatch(setPath(path));
    const currentTabinfo: any = tabsData.filter((item: any) => item.key === tabTitle);
    setTabVal(currentTabinfo[0].index);
  };

  const tabList = {
    siteContactInfo: 'siteContactInfo',
    studyLogs: 'studyLogs',
    path: {
      startup: 'startup',
      DOA: 'DOA',
      SIVTL: 'SIVTL'
    }
  };
  // *End* - PICTMS-2807 - Navigation to respective pages

  return (
    <>
      <AccordionDetails className="sq-checklist-tab">
        <Grid container className="checklist-radio-actions">
          <Grid md={12}>
            <Grid container>
              <Grid md={9}>
                {checklistSiteAdequacy.label1} <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <FormControl>
                  <RadioGroup
                    value={siteAdequacyData.siv_checklist_fics_list}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="siv_checklist_fics_list"
                    onChange={handleSiteAdequancyData}
                  >
                    <FormControlLabel
                      disabled={!isDisable || saveDisable || !checkedInStartDate}
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      disabled={!isDisable || saveDisable || !checkedInStartDate}
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
            <ul>
              <li>
                <Grid container>
                  <Grid md={9}>
                    {checkPermission('view_site_contact_info') ? (
                      <Link
                        onClick={() => navigateToTab(tabList.path.startup, tabList.siteContactInfo)}
                        style={pointer}
                      >
                        {checklistSiteAdequacy.label2} <span style={{ color: 'red' }}>*</span>
                      </Link>
                    ) : (
                      <div>
                        {checklistSiteAdequacy.label2} <span style={{ color: 'red' }}>*</span>
                      </div>
                    )}
                  </Grid>
                  <Grid md={3}>
                    <FormControl>
                      <RadioGroup
                        value={siteAdequacyData.siv_checklist_contact_list}
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="siv_checklist_contact_list"
                        onChange={handleSiteAdequancyData}
                      >
                        <FormControlLabel
                          disabled={
                            !isDisable ||
                            siteAdequacyData.siv_checklist_fics_list === 'Y' ||
                            saveDisable ||
                            !checkedInStartDate
                          }
                          value="Y"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          disabled={
                            !isDisable ||
                            siteAdequacyData.siv_checklist_fics_list === 'Y' ||
                            saveDisable ||
                            !checkedInStartDate
                          }
                          value="N"
                          control={<Radio />}
                          label="No"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </li>
              <li>
                <Grid container>
                  <Grid md={9}>
                    {checkPermission('view_study_logs') && checkPermission('view_site_doa') ? (
                      <Link
                        onClick={() => navigateToTab(tabList.path.DOA, tabList.studyLogs)}
                        style={pointer}
                        underline="always"
                      >
                        {checklistSiteAdequacy.label3} <span style={{ color: 'red' }}>*</span>
                      </Link>
                    ) : (
                      <div>
                        {checklistSiteAdequacy.label3} <span style={{ color: 'red' }}>*</span>
                      </div>
                    )}
                    <Tooltip
                      title="Were all staff CV’s reviewed to confirm that the training and experience of each staff member was adequate for the duties delegated on the Delegation of Authority log?"
                      placement="right"
                    >
                      <Button className="grey-btn">
                        <InfoOutlinedIcon />
                      </Button>
                    </Tooltip>
                  </Grid>
                  <Grid md={3}>
                    <FormControl>
                      <RadioGroup
                        value={siteAdequacyData.siv_checklist_doa}
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="siv_checklist_doa"
                        onChange={handleSiteAdequancyData}
                      >
                        <FormControlLabel
                          disabled={
                            !isDisable ||
                            siteAdequacyData.siv_checklist_fics_list === 'Y' ||
                            saveDisable ||
                            !checkedInStartDate
                          }
                          value="Y"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          disabled={
                            !isDisable ||
                            siteAdequacyData.siv_checklist_fics_list === 'Y' ||
                            saveDisable ||
                            !checkedInStartDate
                          }
                          value="N"
                          control={<Radio />}
                          label="No"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </li>
              <li>
                <Grid container>
                  <Grid md={9}>
                    {checkPermission('view_study_logs') && checkPermission('view_site_siv_training') ? (
                      <Link
                        onClick={() => navigateToTab(tabList.path.SIVTL, tabList.studyLogs)}
                        style={pointer}
                        underline="always"
                      >
                        {checklistSiteAdequacy.label4} <span style={{ color: 'red' }}>*</span>
                      </Link>
                    ) : (
                      <div>
                        {checklistSiteAdequacy.label4} <span style={{ color: 'red' }}>*</span>
                      </div>
                    )}
                  </Grid>
                  <Grid md={3}>
                    <FormControl>
                      <RadioGroup
                        value={siteAdequacyData.siv_checklist_siv_training}
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="siv_checklist_siv_training"
                        onChange={handleSiteAdequancyData}
                      >
                        <FormControlLabel
                          disabled={
                            !isDisable ||
                            siteAdequacyData.siv_checklist_fics_list === 'Y' ||
                            saveDisable ||
                            !checkedInStartDate
                          }
                          value="Y"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          disabled={
                            !isDisable ||
                            siteAdequacyData.siv_checklist_fics_list === 'Y' ||
                            saveDisable ||
                            !checkedInStartDate
                          }
                          value="N"
                          control={<Radio />}
                          label="No"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </li>
            </ul>
            <Grid container>
              <Grid md={9}>
                {checklistSiteAdequacy.label5} <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <FormControl>
                  <RadioGroup
                    value={siteAdequacyData.siv_checklist_study_supplies}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="siv_checklist_study_supplies"
                    onChange={handleSiteAdequancyData}
                  >
                    <FormControlLabel
                      disabled={!isDisable || saveDisable || !checkedInStartDate}
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      disabled={!isDisable || saveDisable || !checkedInStartDate}
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container>
              <Grid md={3}>
                <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                  <InputLabel id="demo-simple-select-standard-label">{checklistSiteAdequacy.label6}</InputLabel>
                  <Select
                    disabled={!isDisable || saveDisable || !checkedInStartDate}
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    onChange={handleAddEquipment}
                    label="Age"
                  >
                    {equipmentData.map((name: any) => (
                      <MenuItem key={name} value={name}>
                        {name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container>
              <Grid md={12}>
                <Stack direction="row" spacing={1}>
                  {siteAdequacyData.siv_checklist_equipment?.length > 0 &&
                    siteAdequacyData.siv_checklist_equipment.map((item: string) => {
                      return (
                        <Chip
                          label={item}
                          key={item}
                          variant="outlined"
                          onDelete={() => handleDelete(item)}
                          disabled={!isDisable || saveDisable || !checkedInStartDate}
                        />
                      );
                    })}
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
      <Grid container className="fixed-buttons-block">
        <Grid md={12} display="flex" justifyContent="flex-end">
          <Stack spacing={2} direction="row">
            {isDisable ? (
              <Button
                onClick={updateSiteAdequancyData}
                variant="text"
                disabled={saveButtonDisable.siteAdequacy || !checkedInStartDate}
              >
                SAVE
              </Button>
            ) : (
              ''
            )}
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default SiteAdequacy;
